import { render } from "./Cabecera.vue?vue&type=template&id=013f3b79&scoped=true"
import script from "./Cabecera.vue?vue&type=script&lang=js"
export * from "./Cabecera.vue?vue&type=script&lang=js"

import "./Cabecera.vue?vue&type=style&index=0&id=013f3b79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013f3b79"]])

export default __exports__